//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'CreatePostPreviewStack',
  props: {
    post: {
      type: Object,
      required: false
    },
    socialAccount: {
      type: Object,
      required: false
    },
    numberOfPosts: {
      type: Number,
      required: true
    },
    /**
     * The media chosen from the Content Library. Displayed in
     * the default preview before a social account is selected.
     */
    media: {
      type: Object,
      required: false
    }
  }
}
